import React from 'react';
import { Link } from 'gatsby';

const ThankYou = () => {
    return (
        <div className="thank-you">
            <div className="thank-you__logo">
                <img src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/7b9962b7f4d80eb929d1cfdab242b8798256454c.png?v=1756753397" alt="logo" />
            </div>
            <h1 className="thank-you__title">
                We've got you covered!
            </h1>
            <p className="thank-you__description">
                Ticket submitted successfully.
            </p>
            <p className="thank-you__description">
                Thank you for reaching out, we’ll get back to you shortly.
            </p>

            <h2 className="thank-you__subtitle">
                What’s next?
            </h2>

            <ul>
                <li>
                    A confirmation email has been sent to you with your ticket details.
                </li>
                <li>
                    Our team will carefully review your request.
                </li>
                <li>
                    You can expect a reply within 48 hours.
                </li>
            </ul>

            <div className="thank-you__buttons">
                <Link to="/" className='thank-you__button thank-you__button--primary '>
                    Homepage
                </Link>

                <Link to="/pages/faq" className='thank-you__button thank-you__button--secondary'>
                    Visit FAQ
                </Link>

            </div>

            <p className="thank-you__description thank-you__description--narrow">
                We know your time is valuable, and we’re here to make things right. Thanks for trusting us!
            </p>

            <p className="thank-you__description thank-you__description--last">
                In case you’d like immediate assistance, our support team
                is available at <a href="tel:8009150038">800-915-0038</a> or through live chat.
            </p>
        </div>
    );
};

export default ThankYou;